import { render, staticRenderFns } from "./DirectMatchReadPopup.vue?vue&type=template&id=08673a00"
import script from "./DirectMatchReadPopup.vue?vue&type=script&lang=js"
export * from "./DirectMatchReadPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports